import { ANY_AMPLOYEE } from '../BookAppointments.constants';
import { getNewExtraTimeAddOns, getPickedEmployee, ScrollToTopElement } from '../BookAppointment.helpers';
import { useBookAppointmentContext } from '../BookAppointment.hooks';
import CardWrapper from '@/components/modules/CardWrapper';
import { HeaderButtonIdentifier } from '@/components/elements/HeaderButton/HeaderButton.types';
import { ListItem, ListItemContent } from '@/components/elements/lists';
import MerchantLogo from '@/components/elements/MerchantLogo/MerchantLogo';
import Icon from '@/components/icons/Icon';
import CheckoutViewLayout from '@/components/layouts/CheckoutViewLayout';
import { bookingFlowTrackingSession } from '@/helpers/checkoutFlowTrackingSession';
import { useAppSelector } from '@/hooks';
import { _t, _s } from '@/locale';
import { BookState, ExtraTimeRequirement, EXTRA_TIME_REQUIREMENT } from '@/types/state/book';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Modal from '../../redesign/Modal/Modal';

const baseTranslationKey = 'components.modules.modals.BookAppointment.views.PickExtraTimeView';

const PickExtraTimeView = () => {
  const context = useBookAppointmentContext();
  const history = useHistory();
  const { employee, place, services: pickedServices, campaigns } = useAppSelector((state) => state.book) as BookState;
  const pickedEmployee = getPickedEmployee(employee, place.employees);
  const shouldGoToCalendar = place?.about && pickedServices?.length > 0;
  const logo = place?.about?.profileImage;
  const handleGoBack = useCallback(() => {
    context.onGoBack('pickExtraTime');
  }, [context]);
  const dealCampaign = campaigns.find((campaign) => campaign.type === 7 && campaign.publicationType === 2);
  const isSistaminutenFlow = Boolean(place.lastMinuteDiscount);
  const isDealsFlow = dealCampaign !== undefined;

  let search = undefined;

  if (isSistaminutenFlow) {
    search = '?sistaminuten=1';
  } else if (isDealsFlow) {
    search = '?dealId=' + dealCampaign.id;
  }

  const handleExtraTime = (value: ExtraTimeRequirement) => () => {
    context.onPickExtraTime(value);
    if (value === EXTRA_TIME_REQUIREMENT.NeedsExtraTime) {
      const extraTimeAddOns = getNewExtraTimeAddOns(pickedServices ?? [], pickedEmployee ?? ANY_AMPLOYEE);
      if (extraTimeAddOns.length > 0) {
        extraTimeAddOns.forEach((item) => {
          context.onPickService(item, true);
        });
      }
    }

    if (shouldGoToCalendar) {
      history.push({
        pathname: `/boka-tjanst/${place.about.slug ? place.about.slug + '-' : ''}${place.id}/${
          pickedServices[0].about.slug
        }-${pickedServices[0].id}`,
        search,
      });
      bookingFlowTrackingSession.searchTime();
      context.close();
    }
  };

  return (
    <Modal.Content floating={false} classNames="bg-primary-200 pt-xl sm:pt-4xl">
      <ScrollToTopElement />
      <CheckoutViewLayout
        header={{
          leftSlot: {
            button: {
              onClick: handleGoBack,
              isActive: false,
              'aria-label': _t('goBack'),
              item: { icon: 'back', identifier: HeaderButtonIdentifier.Back },
            },
            text: _t('goBack'),
          },
          middleSlot: {
            title: _s(`${baseTranslationKey}.title`),
            subtitle: place?.about?.name,
          },
          rightSlot: {
            ...(logo && { imgUrl: logo }),
          },
        }}
        wrapperClass="">
        <div className="flex flex-col items-center justify-center">
          <CardWrapper className="sm:!shadow-xs lg:!shadow-xs max-w-[600px] bg-inherit sm:!rounded-lg sm:bg-white">
            <div className="py-md sm:py-xl flex justify-center">
              <MerchantLogo imgUrl={logo} alt={place?.about?.name ?? ''} size="lg" cornerRadius="rounded-lg" />
            </div>
            <div className="gap-4xl py-lg px-md sm:px-2xl flex flex-col">
              <h3 className="text-black-900 text-center text-[30px] font-bold sm:text-4xl">
                {_s(`${baseTranslationKey}.heading`)}
              </h3>
              <ul className="gap-md flex flex-col">
                <ListItem
                  className="border-black-200 pl-lg rounded-md border bg-white sm:bg-inherit"
                  onClick={handleExtraTime(EXTRA_TIME_REQUIREMENT.NeedsExtraTime)}
                  rightSlot={<Icon variant="arrow-right" />}
                  leftPadding={false}>
                  <ListItemContent
                    content={_s(`${baseTranslationKey}.item1.subtitle`)}
                    contentClassName="mt-[5px]"
                    title={_s(`${baseTranslationKey}.item1.title`)}
                  />
                </ListItem>
                <ListItem
                  className="border-black-200 pl-lg rounded-md border bg-white sm:bg-inherit"
                  onClick={handleExtraTime(EXTRA_TIME_REQUIREMENT.NoExtraTime)}
                  rightSlot={<Icon variant="arrow-right" />}
                  leftPadding={false}>
                  <ListItemContent
                    content={_s(`${baseTranslationKey}.item2.subtitle`)}
                    contentClassName="mt-[5px]"
                    title={_s(`${baseTranslationKey}.item2.title`)}
                  />
                </ListItem>
              </ul>
            </div>
          </CardWrapper>
        </div>
      </CheckoutViewLayout>
    </Modal.Content>
  );
};

export default PickExtraTimeView;
